import { render, staticRenderFns } from "./AdminModuleTemplatesPopup.vue?vue&type=template&id=622c3226&scoped=true&"
import script from "./AdminModuleTemplatesPopup.vue?vue&type=script&lang=js&"
export * from "./AdminModuleTemplatesPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c3226",
  null
  
)

export default component.exports